var map = {
	"./_next.png": 1333,
	"./_prev.png": 1334,
	"./agpaginationbtn/btFirst.svg": 1335,
	"./agpaginationbtn/btLast.svg": 1336,
	"./agpaginationbtn/btNext.svg": 1337,
	"./agpaginationbtn/btPrevious.svg": 1338,
	"./bed-outline.png": 1339,
	"./c5.jpg": 1340,
	"./c6.jpg": 858,
	"./c7.jpg": 1341,
	"./c9.jpg": 1342,
	"./calendar-outline.png": 1343,
	"./calendar-outline1.png": 262,
	"./calendar.png": 857,
	"./caro3.jpg": 1344,
	"./caro7.jpg": 1345,
	"./caro8.jpg": 1346,
	"./check.png": 888,
	"./close_icon.png": 575,
	"./cloud-computing.png": 621,
	"./defaultRoom.png": 1347,
	"./defaultRoomImg.png": 1348,
	"./details.png": 1349,
	"./dropcloseicon.png": 862,
	"./dropcloseicon1.png": 1350,
	"./guesthouse.jpg": 1351,
	"./happy.png": 890,
	"./hero-banner1.png": 931,
	"./highlights_tick.png": 541,
	"./homestay.png": 1352,
	"./hotel.png": 265,
	"./imageIcon.png": 1353,
	"./location.png": 1354,
	"./location1.png": 863,
	"./loginIcon.png": 1355,
	"./next.png": 860,
	"./no-icon.png": 1356,
	"./no-icon1.png": 90,
	"./no-picture.jpg": 375,
	"./pencilColor.png": 866,
	"./people-outline.png": 1357,
	"./people-outline1.png": 864,
	"./pls.png": 657,
	"./prev.png": 859,
	"./profile-back.png": 603,
	"./qr-code.png": 1358,
	"./resetIcon.png": 1359,
	"./searchicon.png": 1360,
	"./searchicon1.png": 622,
	"./shield.png": 1361,
	"./smartphone1.png": 1362,
	"./smartphone2.png": 1363,
	"./stateLoaderImage.png": 353,
	"./staticmap.png": 872,
	"./staying-pic-arunachal.png": 1364,
	"./staying-pic-meghalaya.png": 1365,
	"./staying-pic-odisha.png": 1366,
	"./staying-pic-sikkim.png": 1367,
	"./staying-pic-tamil-nadu.png": 1368,
	"./staying-pic-west-bengal.png": 1369,
	"./stayingLogo.png": 580,
	"./stayingLogoNew.png": 539,
	"./stayingLogoWhite.png": 588,
	"./tickicon.png": 1370,
	"./toastify/bell.png": 891,
	"./toastify/error.png": 1371,
	"./toastify/errorimg.png": 892,
	"./toastify/info.png": 893,
	"./toastify/information.png": 894,
	"./toastify/success.png": 1372,
	"./toastify/successimg.png": 895,
	"./toastify/warning.png": 1373,
	"./toastify/warnningIcon.png": 896,
	"./trendingImg1.png": 929,
	"./trendingImg2.png": 1374,
	"./trendingImg3.png": 1375,
	"./trendingImg4.png": 1376,
	"./trendingImg5.png": 1377,
	"./trendingImg6.png": 1378,
	"./trendingImg7.png": 1379,
	"./unapprovedicon.png": 1380,
	"./updateIcon.png": 867,
	"./uploadFile.png": 1381,
	"./usericon.png": 854,
	"./vietnam.jpg": 1382,
	"./warning.png": 1383,
	"./zoom-in.png": 578,
	"./zoom-out.png": 579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 264;